﻿function getSchedulerState(scheduler: kendo.ui.Scheduler) {
    return kendo.stringify({
        date: scheduler.date(),
        view: scheduler.view().name
    });
}

function setSchedulerSettings(scheduler: kendo.ui.Scheduler) {
    const schedulerSettings = window.getQueryParams()['schedulerSettings'];

    if (schedulerSettings) {
        const jsonReplace = schedulerSettings.replaceAll(/%22/g, '"').replaceAll(/%7B/g, '{').replaceAll(/%7D/g, '}');
        const settings: null | { date: Date, view: string } = JSON.parse(jsonReplace.toString());

        if (settings) {
            function skipFirstRequest(event: Event) {
                event.preventDefault();

                scheduler.unbind('dataBinding', skipFirstRequest);
                scheduler.date(new Date(settings!.date));
            }

            scheduler.bind('dataBinding', skipFirstRequest);
            scheduler.view(settings.view);
        }
    }
}

function adjustSchedulerHeight() {
    $('.k-scheduler:not(.no-adjust)').each(function () {
        const scheduler = $(this);
        scheduler.css('height', `${innerHeight - scheduler.offset()!.top - 15}px`);
        setTimeout(kendo.resize.bind(null, this, false));
    });
}

window.adjustSchedulerHeight = adjustSchedulerHeight;
window.getSchedulerState = getSchedulerState;
window.setSchedulerSettings = setSchedulerSettings;